module.exports = __webpack_public_path__ + "media/packs/images/flags/ZM-7036a7ccbe0f4a095509ada8f084d5c1.svg";